import { useTranslation } from "react-i18next";
import React from "react";
import {EventSettingsItem} from "./EventSettingsItem";
import {isObjectEmpty} from "../../../../../../helpers/tools";

function EventsSettings({event, setEvent}){
    const events_rehersals_name = ['rehearsal', 'raccord', 'min_raccord_duration', 'break_after_raccord_duration']

    return (
        <>
            <div className='px-2'>
                {events_rehersals_name.map((event_reh_name, index) => (
                    event[event_reh_name] && <EventSettingsItem fieldName={event_reh_name} event={event} setEvent={setEvent} key={index}/>
                ))}
            </div>
        </>
        )
    }
export default EventsSettings;